import React from "react";
import { Helmet } from "react-helmet-async";
import Logo from "../../assets/custom/images/Logo.png";

const SEOComponent = ({ title, description, url }) => {
  console.log({ title, description, url });
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:type' content='website' />
      <meta property='og:url' content={url} />
      <meta
        property='og:image'
        content='https://kanraj.com/wp-content/uploads/2022/10/Final-logo-color.png'
      />
      <meta property='og:description' content={description} />
    </Helmet>
  );
};

export default SEOComponent;
